import React, { Component } from 'react';
import classnames from 'classnames';

import { Link } from 'react-router-dom';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

class TabStructure extends Component {
    state = {
        expandTab: false
    };

    expandTab = () => {
        this.setState({
            expandTab: !this.state.expandTab
        });
    };

    onSelect = () => {
        this.setState({
            expandTab: false
        });
    };

    render() {
        const items = this.props.items;
        const activeIndex = items.findIndex(
            item => item.path === this.props.tab
        );
        const tabClass = classnames('tab__child-nav', {
            'is-active': this.state.expandTab
        });
        return (
            <div className={tabClass}>
                <button onClick={this.expandTab} className="tab__child-select">
                    <span className="tab__child-select-title">
                        {items[activeIndex].title}
                    </span>
                    <i className="arrow" />
                </button>
                <Tabs
                    onSelect={this.onSelect}
                    selectedIndex={activeIndex}
                    selectedTabClassName="is-active"
                >
                    <TabList className="tab__child-list">
                        {items.map(item => (
                            <Link key={item.title} to={item.path}>
                                <Tab className="tab__child-link">
                                    {item.title}
                                </Tab>
                            </Link>
                        ))}
                    </TabList>
                    <div className="tab__content">
                        {items.map(item => (
                            <TabPanel key={item.title}>{item.content}</TabPanel>
                        ))}
                    </div>
                </Tabs>
            </div>
        );
    }
}

export default TabStructure;



// WEBPACK FOOTER //
// ./src/components/ui/tab.js